module.exports = __webpack_public_path__ + "media/images/service/n_11-b178821315f1e38b1802f5b9504ef0f7.jpg";